/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductStagingFromJSON, ProductStagingToJSON, } from './ProductStaging';
/**
 * @export
 */
export const ProductStagingSourceDTOMerchantTypeEnum = {
    Fba: 'FBA',
    Fbm: 'FBM',
    Sba: 'SBA'
};
/**
 * Check if a given object implements the ProductStagingSourceDTO interface.
 */
export function instanceOfProductStagingSourceDTO(value) {
    return true;
}
export function ProductStagingSourceDTOFromJSON(json) {
    return ProductStagingSourceDTOFromJSONTyped(json, false);
}
export function ProductStagingSourceDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'productStaging': json['productStaging'] == null ? undefined : ProductStagingFromJSON(json['productStaging']),
        'purchasePriceUsd': json['purchasePriceUsd'] == null ? undefined : json['purchasePriceUsd'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'title': json['title'] == null ? undefined : json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'rootCategory': json['rootCategory'] == null ? undefined : json['rootCategory'],
        'leafCategory': json['leafCategory'] == null ? undefined : json['leafCategory'],
        'reviewRating': json['reviewRating'] == null ? undefined : json['reviewRating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'categoryBsr': json['categoryBsr'] == null ? undefined : json['categoryBsr'],
        'subcategoryBsr': json['subcategoryBsr'] == null ? undefined : json['subcategoryBsr'],
        'merchantType': json['merchantType'] == null ? undefined : json['merchantType'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'isBestSeller': json['isBestSeller'] == null ? undefined : json['isBestSeller'],
        'sourceShippingPriceUsd': json['sourceShippingPriceUsd'] == null ? undefined : json['sourceShippingPriceUsd'],
        'sourceTotalOfferCount': json['sourceTotalOfferCount'] == null ? undefined : json['sourceTotalOfferCount'],
        'sourcePrimeOfferCount': json['sourcePrimeOfferCount'] == null ? undefined : json['sourcePrimeOfferCount'],
        'deliveryPromiseDays': json['deliveryPromiseDays'] == null ? undefined : json['deliveryPromiseDays'],
        'returnable': json['returnable'] == null ? undefined : json['returnable'],
        'freeReturns': json['freeReturns'] == null ? undefined : json['freeReturns'],
        'returnWindowDays': json['returnWindowDays'] == null ? undefined : json['returnWindowDays'],
        'amazonsChoice': json['amazonsChoice'] == null ? undefined : json['amazonsChoice'],
        'primeExclusive': json['primeExclusive'] == null ? undefined : json['primeExclusive'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'voltage': json['voltage'] == null ? undefined : json['voltage'],
        'bulbBase': json['bulbBase'] == null ? undefined : json['bulbBase'],
        'powerSource': json['powerSource'] == null ? undefined : json['powerSource'],
        'sourceSellerId': json['sourceSellerId'] == null ? undefined : json['sourceSellerId'],
        'sourceSellerName': json['sourceSellerName'] == null ? undefined : json['sourceSellerName'],
        'sourceSellerCountry': json['sourceSellerCountry'] == null ? undefined : json['sourceSellerCountry'],
        'sourceInfoLastModifiedDate': json['sourceInfoLastModifiedDate'] == null ? undefined : (new Date(json['sourceInfoLastModifiedDate'])),
    };
}
export function ProductStagingSourceDTOToJSON(json) {
    return ProductStagingSourceDTOToJSONTyped(json, false);
}
export function ProductStagingSourceDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'productStaging': ProductStagingToJSON(value['productStaging']),
        'purchasePriceUsd': value['purchasePriceUsd'],
        'brand': value['brand'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'rootCategory': value['rootCategory'],
        'leafCategory': value['leafCategory'],
        'reviewRating': value['reviewRating'],
        'reviewCount': value['reviewCount'],
        'categoryBsr': value['categoryBsr'],
        'subcategoryBsr': value['subcategoryBsr'],
        'merchantType': value['merchantType'],
        'availability': value['availability'],
        'isBestSeller': value['isBestSeller'],
        'sourceShippingPriceUsd': value['sourceShippingPriceUsd'],
        'sourceTotalOfferCount': value['sourceTotalOfferCount'],
        'sourcePrimeOfferCount': value['sourcePrimeOfferCount'],
        'deliveryPromiseDays': value['deliveryPromiseDays'],
        'returnable': value['returnable'],
        'freeReturns': value['freeReturns'],
        'returnWindowDays': value['returnWindowDays'],
        'amazonsChoice': value['amazonsChoice'],
        'primeExclusive': value['primeExclusive'],
        'availableQuantity': value['availableQuantity'],
        'voltage': value['voltage'],
        'bulbBase': value['bulbBase'],
        'powerSource': value['powerSource'],
        'sourceSellerId': value['sourceSellerId'],
        'sourceSellerName': value['sourceSellerName'],
        'sourceSellerCountry': value['sourceSellerCountry'],
        'sourceInfoLastModifiedDate': value['sourceInfoLastModifiedDate'] == null ? undefined : ((value['sourceInfoLastModifiedDate']).toISOString()),
    };
}
